var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLink = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 32 32",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.2 16a4.137 4.137 0 0 1 4.133-4.133h5.333V9.333H9.333A6.67 6.67 0 0 0 2.666 16a6.67 6.67 0 0 0 6.667 6.667h5.333v-2.534H9.333A4.137 4.137 0 0 1 5.199 16zm5.466 1.333h10.667v-2.666H10.666v2.666zm12-8h-5.333v2.534h5.333A4.137 4.137 0 0 1 26.799 16a4.137 4.137 0 0 1-4.133 4.133h-5.333v2.534h5.333A6.67 6.67 0 0 0 29.333 16a6.67 6.67 0 0 0-6.667-6.667z",
  fill: "#A1A3A5"
})));
export default SvgLink;